import React, { ReactNode } from 'react';
import { PrescriptionProvider } from '../providers/PrescriptionProvider';
import ThemeProvider from '../shared/theme/ThemeProvider';
import { EmissionProvider } from '../providers/EmissionProvider';
import { FeedbackProvider } from '../providers/FeedbackProvider';

interface CombinedProvidersProps {
  children: ReactNode;
}

function CombinedProviders(props: CombinedProvidersProps) {
  return (
    <ThemeProvider>
      <FeedbackProvider>
        <PrescriptionProvider>
          <EmissionProvider>{props.children}</EmissionProvider>
        </PrescriptionProvider>
      </FeedbackProvider>
    </ThemeProvider>
  );
}

export default CombinedProviders;
